import MuiButton from './MuiButton';
import MuiSelect from './MuiSelect';

export default {
  MuiButton,
  MuiSelect,
};
